import m from 'mithril';
import '../css/christmasSled.scss';

const christmasSled = {
	name: 'vwChristmasSled',
	view: () => {
		return m(
			'div',
			{
				style: 'display: flex; justify-content: center; align-items: center; overflow: hidden; width: 100vw; padding-bottom: 50px ',
			},
			m('div', { class: 'sleigh-santa', style: 'display: block' }, [
				m('div', { class: 'santa santa--sleigh' }, [
					m('div', { class: 'santa__hat' }, [m('div', { class: 'santa__hat-part' }), m('div', { class: 'santa__hat-part' })]),
					m('div', { class: 'santa__face' }, [
						m('div', { class: 'santa__eyebrows santa__eyebrows--right' }),
						m('div', { class: 'santa__eyebrows santa__eyebrows--left' }),
						m('div', { class: 'santa__eye santa__eye--right' }),
						m('div', { class: 'santa__eye santa__eye--left' }),
						m('div', { class: 'santa__nose' }),
						m('div', { class: 'santa__cheek santa__cheek--right' }),
						m('div', { class: 'santa__cheek santa__cheek--left' }),
						m('div', { class: 'santa__beard' }, [
							m('div', { class: 'santa__beard-part' }),
							m('div', { class: 'santa__beard-part' }),
							m('div', { class: 'santa__beard-part' }),
						]),
						m('div', { class: 'santa__mouth' }),
					]),
					m('div', { class: 'santa__body' }, [
						m('div', { class: 'santa__body-top' }),
						m('div', { class: 'santa__hand santa__hand--left' }, m('div', { class: 'santa__hand-inner' })),
						m('div', { class: 'santa__hand santa__hand--right' }),
					]),
				]),
				m('div', { class: 'sleigh-feet' }),
				m('div', { class: 'lead' }, m('div', { class: 'lead-inner' })),
				m('div', { class: 'lead lead--back' }, m('div', { class: 'lead-inner' })),
				m('div', { class: 'reindeer' }, [
					m('div', { class: 'reindeer__face' }, [
						m('div', { class: 'reindeer__ear' }),
						m('div', { class: 'reindeer__horn reindeer__horn--right' }),
						m('div', { class: 'reindeer__horn reindeer__horn--left' }),
					]),
					m('div', { class: 'reindeer__body' }, [
						m('div', { class: 'reindeer__foot reindeer__foot--front' }, m('div', { class: 'reindeer__foot-inner' })),
						m(
							'div',
							{ class: 'reindeer__foot reindeer__foot--front reindeer__foot--inside' },
							m('div', { class: 'reindeer__foot-inner' })
						),
						m('div', { class: 'reindeer__foot reindeer__foot--back' }, m('div', { class: 'reindeer__foot-inner' })),
						m(
							'div',
							{ class: 'reindeer__foot reindeer__foot--back reindeer__foot--inside' },
							m('div', { class: 'reindeer__foot-inner' })
						),
						m('div', { class: 'reindeer__tail' }),
						m('div', { class: 'reindeer__spots' }),
					]),
				]),
				m('div', { class: 'particles' }),
			])
		);
	},
};

export default christmasSled;
